import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { postRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';

const AddAchievement = () => {
  const [heading, setHeading] = useState('');
  const [isActive, setIsActive] = useState('1');
  const [imageFile, setImageFile] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = new FormData();
    payload.append('heading', heading);
    payload.append('is_active', isActive);
    if (imageFile) payload.append('image', imageFile);

    try {
      await postRequest('achievements', payload, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      toast.success('Achievement added successfully!', {
        position: 'top-right',
        autoClose: 2000
      });
      setTimeout(() => {
        navigate('/achievements');
      }, 2000);
    } catch (error) {
      console.error('Failed to add achievement:', error);
      toast.error('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Add Achievement</h4>
      </div>
      <div className="mx-4">
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="row">
            <div className="col-sm-6 mt-2">
              <label className="admin-label" htmlFor="heading">Heading</label>
              <input
                id="heading"
                type="text"
                name="heading"
                placeholder="Enter heading"
                className="form-control"
                value={heading}
                onChange={(e) => setHeading(e.target.value)}
                required
              />
            </div>
            <div className="col-sm-3 mt-2">
              <label className="admin-label" htmlFor="status">Status</label>
              <select
                id="status"
                name="is_active"
                className="form-control"
                value={isActive}
                onChange={(e) => setIsActive(e.target.value)}
              >
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>
            <div className="col-sm-3 mt-2">
              <label className="admin-label" htmlFor="image">Image</label>
              <input
                id="image"
                type="file"
                className="form-control"
                onChange={(e) => setImageFile(e.target.files?.[0] || null)}
                required
              />
            </div>
          </div>

          <button type="submit" className="btn addbtn mt-3">
            Save
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddAchievement;
